// Currency formatting for the Finance module.
//
// Launch market is BRL / pt-BR (replacing the old hardcoded €). We honor a
// per-transaction `currency` when present, otherwise default to BRL.

const FALLBACK_CURRENCY = "BRL";

export function formatMoney(amount: number, currency?: string | null, locale = "pt-BR"): string {
  const cur = (currency || FALLBACK_CURRENCY).toUpperCase();
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: cur,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return "R$ " + amount.toFixed(2);
  }
}

// Whole-number variant for headline figures (hero balance, account balances).
export function formatMoneyShort(amount: number, currency?: string | null, locale = "pt-BR"): string {
  const cur = (currency || FALLBACK_CURRENCY).toUpperCase();
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: cur,
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    return "R$ " + Math.round(amount);
  }
}

/** Review and persisted values must never pass through Number. */
export function formatExactFinanceMoney(amount: string, currency?: string | null): string {
  return [currency || "—", amount].join(" ");
}

export { FALLBACK_CURRENCY };
